import { cva, ConfigSchema, ConfigVariants, Config } from 'class-variance-authority'
import { twMerge } from 'tailwind-merge'
import { ClassValue } from 'clsx'

// prettier-ignore
export type ClassProp =
  | { class: ClassValue; className?: never }
  | { class?: never; className?: ClassValue }

type TCvaProps<T> = T extends ConfigSchema ? ConfigVariants<T> & ClassProp : ClassProp
type TCvaFN<T extends ConfigSchema> = {
  (props?: TCvaProps<T> | undefined): string
}
type TCvaFNWithVariants<T extends ConfigSchema> = TCvaFN<T> & {
  [K in keyof T]: T[K]
}
export const tcva = <T extends ConfigSchema>(base: ClassValue, config: Config<T>): TCvaFNWithVariants<T> => {
  const cvaResult = cva(base, config) as TCvaFN<T>

  const variantsFn: TCvaFN<T> = (props?: TCvaProps<T>) => twMerge(cvaResult(props))

  if (!config.variants) throw new Error('config.variants is required')

  for (const variant of Object.keys(config.variants ?? {})) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (variantsFn as any)[variant] = config.variants[variant]
  }
  return variantsFn as TCvaFNWithVariants<T>
}
